<template>

    <v-form
            ref="modifyUserForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="d-flex fill-height of-y">
            <div style="width: 50%" class="fill-height d-flex flex-column">
                <div class="sub--text pa-1 primary text-center">
                    Information
                </div>
                <v-divider></v-divider>
                <div class="flex-grow-1 of-y px-2">
                    <v-text-field
                            label="Username"
                            hide-details="auto"
                            v-model="user.username"
                            @change="changesMade = true"
                            autocomplete="new-password"
                            :rules="[validationRules.required, validationRules.notNull, validationRules.email]"
                            :error-messages="usernameErrorMessages"
                    />
                    <v-text-field
                            ref="passwordField"
                            v-if="user.id === null || editPassword"
                            label="Password"
                            placeholder="New Password"
                            hide-details="auto"
                            v-model="user.password"
                            @change="changesMade = true"
                            type="password"
                            autocomplete="new-password"
                            :rules="[validationRules.notNull, validationRules.required, validationRules.min6Characters, validationRules.specialCharacter, validationRules.upperCase, validationRules.lowerCase, validationRules.numeric,]"
                    />
                    <div class="text-center">
                        <v-btn
                                v-if="!editPassword && !!user.id"
                                small
                                color="primary"
                                class="mt-2"
                                @click="editPassword = true; $nextTick(() => {$refs.passwordField.focus()})"
                        >
                            <v-icon>mdi-mdi-key-variant</v-icon>
                            Edit Password
                        </v-btn>
                    </div>

                    <v-text-field
                            label="Name"
                            hide-details="auto"
                            v-model="user.name"
                            @change="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                    <v-text-field
                            label="Surname"
                            hide-details="auto"
                            v-model="user.surname"
                            @change="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull]"
                    />
                </div>
            </div>
            <divider color="primary darken-1" :vertical="true"/>
            <div style="width: 50%" class="fill-height d-flex flex-column">
                <div class="sub--text pa-1 primary text-center">
                    Options
                </div>
                <v-divider></v-divider>
                <div class="flex-grow-1 of-y px-2">
                    <v-switch
                            label="Disabled"
                            color="primary"
                            v-model="user.disabled"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="User Manager"
                            color="primary"
                            v-model="user.adminOptions.users"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                  <v-switch
                    :disabled="user.adminOptions.setup || user.adminOptions.users"
                    label="Issue Warrants"
                    color="primary"
                    v-model="issueWarrants"
                    hide-details
                    @change="changesMade = true"
                  ></v-switch>
                    <v-switch
                            label="Farms Manager"
                            color="primary"
                            v-model="user.adminOptions.farms"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="Varieties Manager"
                            color="primary"
                            v-model="user.adminOptions.varieties"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="Blocks Manager"
                            color="primary"
                            v-model="user.adminOptions.blocks"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="Employees Manager"
                            color="primary"
                            v-model="user.adminOptions.employees"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="Piecework Manager"
                            color="primary"
                            v-model="user.adminOptions.piecework"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                    <v-switch
                            label="Devices Manager"
                            color="primary"
                            v-model="user.adminOptions.devices"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>

                    <v-switch
                            label="Setup Manager"
                            color="primary"
                            v-model="user.adminOptions.setup"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>

                    <v-switch
                            label="Recruitment"
                            color="primary"
                            v-model="recruitment"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>
                  
                  <v-switch
                      label="Recruitment Archive"
                      color="primary"
                      v-model="recruitmentArchived"
                      hide-details
                      @change="changesMade = true"
                  ></v-switch>

                  <v-switch
                    :disabled="!user.adminOptions.recruitment"
                    label="Recruitment Excel Export"
                    color="primary"
                    v-model="recruitmentExport"
                    hide-details
                    @change="changesMade = true"
                  ></v-switch>

                    <v-switch
                            label="HR Pin Management"
                            color="primary"
                            v-model="pinManagement"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>

                    <v-switch
                            label="HR Contracts Management"
                            color="primary"
                            v-model="contractsManagement"
                            hide-details
                            @change="changesMade = true"
                    ></v-switch>

                    <v-switch
                        label="Employee Status Setup"
                        color="primary"
                        v-model="statusManagement"
                        hide-details
                        @change="changesMade = true"
                    ></v-switch>

                    <v-switch
                        label="Employee Warnings Setup"
                        color="primary"
                        v-model="warningsManagement"
                        hide-details
                        @change="changesMade = true"
                    ></v-switch>
                  
                  <v-switch
                      label="Shifts Setup"
                      color="primary"
                      v-model="shiftsManagement"
                      hide-details
                      @change="changesMade = true"
                  ></v-switch>

                    <v-autocomplete
                            :outlined="true"
                            @input="changesMade = true"
                            :dense="true"
                            label="Limit To Farms"
                            placeholder="None = All Farms"
                            :items="farms"
                            v-model="user.adminOptions.limitToFarms"
                            :multiple="true"
                            item-value="id"
                            item-text="description"
                            color="primary"
                            class="pt-4"
                            :hide-details="true"
                    ></v-autocomplete>
                </div>
            </div>
            <divider color="primary darken-1" :vertical="true"/>
            <div v-if="editUser.id" style="width: 50%" class="fill-height d-flex flex-column">
                <div class="sub--text pa-1 primary text-center">
                    Barcodes
                </div>
                <v-divider></v-divider>
                <slot name="barcodes"/>
            </div>
        </div>
        <div style="position: absolute; bottom: 0; right: 0" class="pa-2">
            <v-btn
                    @click="validateSave()"
                    fab
                    small
                    color="secondary"
                    :loading="loading"
                    :disabled="!changesMade || loading"
            >
                <v-icon v-if="!loading">mdi-content-save</v-icon>
            </v-btn>
        </div>
    </v-form>


</template>

<script>
import {mapGetters} from 'vuex';
import {validationRules} from "../../../core/codeFunctions";
import Divider from "../../General/Divider";

export default {
    components: {Divider},
    props: {
        editUser: Object,
        showBarcodes: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            user: false,
            changesMade: false,
            validationRules: validationRules,
            usernameErrorMessages: null,
            loading: false,
            editPassword: false
        }
    },
    watch: {
        editUser: {
            deep: true,
            immediate: true,
            handler(val) {
                this.editPassword = false;
                this.changesMade = false
                this.user = JSON.parse(JSON.stringify(val))
                if (!this.user.adminOptions)
                    this.user.adminOptions = {
                        users: false,
                        setup: false,
                        limitToFarms: []
                    }

                if (!this.user.adminOptions.limitToFarms) {this.user.adminOptions.limitToFarms = []}
                if (!this.user.adminOptions.farms) {this.user.adminOptions.farms = false}
                if (!this.user.adminOptions.varieties) {this.user.adminOptions.varieties = false}
                if (!this.user.adminOptions.blocks) {this.user.adminOptions.blocks = false}
                if (!this.user.adminOptions.employees) {this.user.adminOptions.employees = false}
                if (!this.user.adminOptions.piecework) {this.user.adminOptions.piecework = false}
                if (!this.user.adminOptions.devices) {this.user.adminOptions.devices = false}
                this.user.adminOptions.shifts = this.user.adminOptions.shifts ?? false


                this.user.password = this.user.password || null
            }
        },
        "user.username"() {
            this.usernameErrorMessages = null
        }
    },
    methods: {
        validateSave() {
            // Check Username
            if (this.editUser.username !== this.user.username) {
                if (this.users.filter(obj => obj.username.toLowerCase() === this.user.username.toLowerCase()).length) {
                    this.usernameErrorMessages = ['Username already exists']
                    return false
                }
            }
            if (!this.$refs.modifyUserForm.validate())
                return false

            this.$emit('save', {user: this.user, ref: this})
        }
    },
    computed: {
        ...mapGetters(['users', 'farms']),
      issueWarrants: {
        get() {
          if (this.user.adminOptions.setup || this.user.adminOptions.users)
            return true

          return this.user.adminOptions.issueWarrants ? this.user.adminOptions.issueWarrants : false
        },
        set(val) {
          if (typeof this.user.adminOptions.issueWarrants == 'undefined')
            this.$set(this.user.adminOptions, 'issueWarrants', val)

          this.user.adminOptions.issueWarrants = val
        }
      },
        recruitment: {
            get() {
                return this.user.adminOptions.recruitment ? this.user.adminOptions.recruitment : false
            },
            set(val) {
                if (typeof this.user.adminOptions.recruitment == 'undefined')
                    this.$set(this.user.adminOptions, 'recruitment', val)

                this.user.adminOptions.recruitment = val
            }
        },
      recruitmentArchived: {
        get() {
          return this.user.adminOptions.recruitmentArchived ? this.user.adminOptions.recruitmentArchived : false
        },
        set(val) {
          if (typeof this.user.adminOptions.recruitmentArchived == 'undefined')
            this.$set(this.user.adminOptions, 'recruitmentArchived', val)
          
          this.user.adminOptions.recruitmentArchived = val
        }
      },
      recruitmentExport: {
        get() {

          if (!this.user.adminOptions.recruitment)
            return false

          return this.user.adminOptions.recruitmentExport ? this.user.adminOptions.recruitmentExport : false
        },
        set(val) {
          if (typeof this.user.adminOptions.recruitmentExport == 'undefined')
            this.$set(this.user.adminOptions, 'recruitmentExport', val)

          this.user.adminOptions.recruitmentExport = val
        }
      },
        pinManagement: {
            get() {
                return this.user.adminOptions.pinManagement ? this.user.adminOptions.pinManagement : false
            },
            set(val) {
                if (typeof this.user.adminOptions.pinManagement == 'undefined')
                    this.$set(this.user.adminOptions, 'pinManagement', val)

                this.user.adminOptions.pinManagement = val
            }
        },
        contractsManagement: {
            get() {
                return this.user.adminOptions.contracts ? this.user.adminOptions.contracts : false
            },
            set(val) {
                if (typeof this.user.adminOptions.contracts == 'undefined')
                    this.$set(this.user.adminOptions, 'contracts', val)

                this.user.adminOptions.contracts = val
            }
        },
        statusManagement: {
            get() {
                return this.user.adminOptions.status ? this.user.adminOptions.status : false
            },
            set(val) {
                if (typeof this.user.adminOptions.status == 'undefined')
                    this.$set(this.user.adminOptions, 'status', val)

                this.user.adminOptions.status = val
            }
        },
      warningsManagement: {
        get() {
          return this.user.adminOptions.warnings ? this.user.adminOptions.warnings : false
        },
        set(val) {
          if (typeof this.user.adminOptions.warnings == 'undefined')
            this.$set(this.user.adminOptions, 'warnings', val)
          
          this.user.adminOptions.warnings = val
        }
      },
      shiftsManagement: {
        get() {
          return this.user.adminOptions.shifts ? this.user.adminOptions.shifts : false
        },
        set(val) {
          if (typeof this.user.adminOptions.shifts == 'undefined')
            this.$set(this.user.adminOptions, 'shifts', val)
          
          this.user.adminOptions.shifts = val
        }
      },
    },
}
</script>

<style scoped>

</style>